import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button, DatePicker, Form, Spin, Table, Typography } from 'antd'
import locale from 'antd/es/date-picker/locale/ru_RU'
import { userSelector } from '../../../store/session'
import { formatDate, dateRange } from '../../../utils/date-format'
import { getAiBillingReport } from '../../../services/web-search'
import _ from 'lodash'
import { exportTableDataToXlsx } from '../../../utils/export-xls'

const { RangePicker } = DatePicker
const { Text } = Typography

const DEFAULT_HEIGHT = window.innerHeight || 600
const DATE_FORMAT = 'DD.MM.YYYY'

const columns = [
  {
    title: 'Дата заявки',
    key: 'application-item-date',
    dataIndex: 'appItemDate',
    align: 'center',
    render: formatDate,
    width: 100,
  },
  {
    title: 'Создано заявок',
    key: 'application-item-count',
    dataIndex: 'appItemCount',
    align: 'right',
    width: 150,
    render: Number,
  },
  {
    title: 'Создано запросов',
    key: 'web-ai-count',
    dataIndex: 'webCount',
    align: 'right',
    width: 150,
    render: Number,
  },
  {
    title: 'Запросов исполнено',
    key: 'web-ai-completed',
    dataIndex: 'webCompleted',
    align: 'right',
    width: 150,
    render: Number,
  },
  {
    title: 'Запросов на ошибке',
    key: 'web-ai-failed',
    dataIndex: 'webFailed',
    align: 'right',
    width: 150,
    render: Number,
  },
  {
    title: 'Токенов на запрос',
    key: 'input-tokens',
    dataIndex: 'inputTokens',
    align: 'right',
    width: 150,
    render: Number,
  },
  {
    title: 'Токенов на ответ',
    key: 'output-tokens',
    dataIndex: 'outputTokens',
    align: 'right',
    width: 150,
    render: Number,
  },
]

const buildFilter = ({ appDates }) => ({
  createdAt: dateRange(appDates),
})

const WebAiBillingReport = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [xScrollEnabled, setXScrollEnabled] = useState(false)
  const [data, setData] = useState([])

  const [form] = Form.useForm()

  const { user } = useSelector(userSelector)

  const onFormSubmit = (values) => {
    setIsLoading(true)

    getAiBillingReport(buildFilter(values))
      .then((response) => {
        const results = response?.data
        if (results) {
          setData(results)
        }
      })
      .catch(() => {
        console.warn('Loading report result error')
      })
      .finally(() => setIsLoading(false))
  }

  const exportData = useCallback(
    () => exportTableDataToXlsx('div.table-ai-billing', null, 'Отчет_по_ИИ_биллингу.xlsx'),
    [data]
  )

  useEffect(() => {
    if (!isLoading && data && data.length > 0) {
      setXScrollEnabled(true)
    }
  }, [isLoading, data])

  const TableSummary = ({ data }) => {
    const totalAppItems = _.sumBy(data, 'appItemCount')
    const totalWebItems = _.sumBy(data, 'webCount')
    const totalWebCompleted = _.sumBy(data, 'webCompleted')
    const totalWebFailed = _.sumBy(data, 'webFailed')
    const totalInputTokens = _.sumBy(data, 'inputTokens')
    const totalOutputTokens = _.sumBy(data, 'outputTokens')
    return (
      <Table.Summary>
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} align="right">
            <Text strong>Итого:</Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={1} align="right">
            <Text strong>{totalAppItems}</Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={2} align="right">
            <Text strong>{totalWebItems}</Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={3} align="right">
            <Text strong>{totalWebCompleted}</Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={4} align="right">
            <Text strong>{totalWebFailed}</Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={5} align="right">
            <Text strong>{totalInputTokens}</Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6} align="right">
            <Text strong>{totalOutputTokens}</Text>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      </Table.Summary>
    )
  }

  return (
    <Spin spinning={isLoading}>
      <Form initialValues={{}} form={form} layout="vertical" style={{ display: 'flex' }} onFinish={onFormSubmit}>
        <Form.Item label="Даты заявки" style={{ marginLeft: 15, maxWidth: 240 }} name="appDates">
          <RangePicker locale={locale} format={DATE_FORMAT} />
        </Form.Item>
        <Form.Item label="" style={{ marginLeft: 15, marginTop: 30 }}>
          <Button onClick={() => form.submit()}>Сформировать отчет</Button>
        </Form.Item>
        <Button style={{ marginLeft: 15, marginTop: 30 }} disabled={data.length === 0} onClick={exportData}>
          Скачать
        </Button>
      </Form>
      <div style={{ paddingTop: 10 }}>
        <Table
          id="aiBillingReportTable"
          className="table-ai-billing"
          columns={columns}
          dataSource={data}
          bordered
          size="small"
          pagination={false}
          scroll={{ x: xScrollEnabled ? 1300 : undefined, y: DEFAULT_HEIGHT - 240 }}
          summary={(pageData) => <TableSummary data={pageData} />}
        />
      </div>
    </Spin>
  )
}

export default WebAiBillingReport
